/*
 * 用户账号信息
 */
/*eslint-disable*/

import store from '../index'
import {register,login,loginByCode,getMeInfo} from '../../api/user'
export function setUserInfo ({commit},data) {
    commit('getUserInfo', data)
}
export function setUser ({commit},data) {
    commit('getUser', data)
}
export function setToken({commit},token){
    commit('getToken', token);
}
// get user info
export function goRegister({ dispatch }, data) {
    return new Promise((resolve, reject) => {
        register( data ).then( () => {
            dispatch('goLogin',{ phone:data.phone, password: data.password }).then( res => {
                resolve(res)
            }).catch( err => {
                reject(err)
            })
        }).catch(error => {
            reject(error)
        })
    })
}
export function goLoginByCode({ dispatch }, data) {
    return new Promise((resolve, reject) => {
        loginByCode({phone:data.phone.trim(),code:data.code}).then(res=>{
            dispatch("setUserInfo",res.data);

            resolve(res)
        }).catch(err=>{
            reject(err)
        });
    })
}
export function goLogin({ dispatch }, data) {
    return new Promise((resolve, reject) => {
        login( { phone: data.phone.trim(), password:data.password } ).then( (res) => {
            resolve(res);
            dispatch("setUserInfo",res.data);
            dispatch('connect')
        }).catch(error => {
            reject(error)
        })
    })
}
/*获得用户登录信息*/
export function getMeInfoData({ dispatch }) {
    return new Promise((resolve, reject) => {
        getMeInfo().then(res=>{
            dispatch("setUser",res.data);
            resolve(res)
        }).catch(err=>{
            reject(err)
        });
    })
}